export const actionTypes = {
  snackNotification: 'SNACK',
}

const notify = (message, variant = 'error') => {
  return {
    type: actionTypes.snackNotification,
    payload: { message, variant },
  }
}

export const actions = {
  notify,
}
